import React from "react";
import "./Skeleton.css";

/**
 * Loading placeholders shaped like the content that is coming.
 *
 * Replaces a centred dot spinner, which tells the visitor only that something
 * is happening. A skeleton tells them what is arriving and where, so the page
 * does not jump when it lands — and the same wait reads as faster.
 *
 * `aria-hidden` with a polite status message, so a screen reader hears
 * "Loading" once rather than reading out a wall of empty boxes.
 */

export const SkeletonGrid = ({ count = 8 }) => (
  <>
    <span className="sr-only" role="status">Loading products</span>
    <div className="sk-grid" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div className="sk-card" key={i}>
          <div className="sk sk-card__img" />
          <div className="sk-card__meta">
            <div className="sk sk-line sk-line--name" />
            <div className="sk sk-line sk-line--price" />
          </div>
        </div>
      ))}
    </div>
  </>
);

export const SkeletonProduct = () => (
  <>
    <span className="sr-only" role="status">Loading product</span>
    <div className="sk-product" aria-hidden="true">
      <div className="sk-product__media">
        <div className="sk sk-product__img" />
        <div className="sk-product__dots">
          <span className="sk sk-dot" /><span className="sk sk-dot" /><span className="sk sk-dot" />
        </div>
      </div>
      <div className="sk-product__info">
        <div className="sk sk-line sk-line--title" />
        <div className="sk sk-line sk-line--price" />
        <div className="sk-rule" />
        <div className="sk sk-line sk-line--label" />
        <div className="sk-product__row">
          <span className="sk sk-chip" /><span className="sk sk-chip" />
          <span className="sk sk-chip" /><span className="sk sk-chip" />
        </div>
        <div className="sk sk-line sk-line--label" />
        <div className="sk-product__row">
          <span className="sk sk-swatch" /><span className="sk sk-swatch" /><span className="sk sk-swatch" />
        </div>
        <div className="sk sk-button" />
      </div>
    </div>
  </>
);

export default SkeletonGrid;
